export default {
  data () {
    return {
      instructionGroups: [],
    }
  },
  methods: {
    loadGroups () {
      request.page('queryTrainingInstructionGroupAll').then(({ data }) => {
        this.instructionGroups = data.map(it => ({value: it.id, label: it.name}))
      })
    },
    deleteInstructionGroup (item) {
      this.$confirm(`确认删除分组「${item.label}」吗？`, '提示', { type: 'warning' }).then(() => {
        return request.common('deleteTrainingInstructionGroup', item.value)
      }).then(() => {
        this.$message.success('删除成功')
        this.onInstructionGroupDeleted(item)
        this.loadGroups()
      }).catch(() => {})
    },
    onInstructionGroupDeleted (item) {
      if (this.form && this.form.instruction_group_name === item.label) {
        this.form.instruction_group_name = null
      }
      if (this.search && Number(this.search.instruction_group_id) === Number(item.value)) {
        this.search.instruction_group_id = null
      }
    },
    getOptionLabel (optType, val) {
      const type = this.options[optType].find((one) => one.value === val)
      return type ? type.label : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/training/training.mixins.js